/* eslint-disable no-restricted-syntax */
import type { FieldPath, FieldValues } from 'react-hook-form';
import { get, useFormContext } from 'react-hook-form';

type Props<TFieldValues extends FieldValues> = {
    name: FieldPath<TFieldValues> | FieldPath<TFieldValues>[];
    className?: string;
    htmlFor?: string;
    errorMessage?: string;
    hideErrors?: boolean;
};

export function ErrorMessage<TFieldValues extends FieldValues>({
    errorMessage,
    hideErrors = false,
    htmlFor,
    name,
}: Props<TFieldValues>) {
    const {
        formState: { errors },
    } = useFormContext();
    if (errors == null || hideErrors) return null;
    if (Object.keys(errors).length === 0) return null;

    let message: string | null = null;
    if (Array.isArray(name)) {
        for (const n of name) {
            const m = get(errors, n);
            if (m != null && m?.message != null && typeof m.message === 'string') {
                message = m.message;
                break;
            }
        }
    } else {
        const m = get(errors, name);
        if (m == null || m?.message == null) return null;
        message = m.message;
    }

    if (message == null) return null;
    message = errorMessage ?? message;

    return (
        <div className="flex flex-wrap items-center gap-2.5">
            <div className="w-full sm:w-1/5 xl:w-40">{/* Create some space here */}</div>
            <div className="flex items-center gap-2.5 grow">
                <label className="w-full text-xs text-red-500 pl-1 pb-1.5" htmlFor={htmlFor} role="alert">
                    {message}
                </label>
            </div>
        </div>
    );
}
